import WayPointData from "./data";

export default function wayPointFromJson(json) {
    return new WayPointData(
        json.latitude,
        json.longitude,
        json.position,
        json.type
    )
}